import { render, staticRenderFns } from "./ComponentProductivityByUser.vue?vue&type=template&id=c39bb66c&scoped=true"
import script from "./ComponentProductivityByUser.vue?vue&type=script&lang=js"
export * from "./ComponentProductivityByUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39bb66c",
  null
  
)

export default component.exports